import "../stylesheets/LoginScreen.css";

import React from "react";

import AuthorizationManager from "../manager/AuthorizationManager";
import ScreenManager from "../manager/ScreenManager";

import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";


const authorizationManager = AuthorizationManager.instance;
const screenManager = ScreenManager.instance;

export default class LoginScreen extends React.Component {

    state = {
        username: "",
        password: "",
        error: "",
        loggingIn: false
    }

    componentDidMount() {
        if (AuthorizationManager.sessionToken) this.login();
    }

    render() {

        return (

            <div className="flexContainer centeredItems" >
                
                <Form onSubmit={this.login.bind(this)} className="centerVertical loginForm" >

                    <Form.Group as={Row} controlId="usernameForm" >
                        <Form.Label column >Nutzername:</Form.Label>
                        <Col>
                            <Form.Control
                                value={this.state.username}
                                isInvalid={this.state.error !== ""}
                                onChange={event => this.setState({ username: event.target.value })}
                                placeholder="Nutzername"
                                disabled={this.state.loggingIn}
                                required
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="passwordForm" >
                        <Form.Label column >Passwort:</Form.Label>
                        <Col>
                            <Form.Control
                                value={this.state.password}
                                isInvalid={this.state.error !== ""}
                                onChange={event => this.setState({ password: event.target.value })}
                                type="password"
                                placeholder="Passwort"
                                disabled={this.state.loggingIn}
                                required
                            />
                        </Col>
                    </Form.Group>

                    <Button className="float-right" type="submit" variant="dark" disabled={this.state.loggingIn} >Login</Button>

                </Form>

                <br/>

                {this.state.error}
            </div>

        );

    }

    /**
     * performs login
     */
    async login( event ) {

        if (event) event.preventDefault();

        try {
            await new Promise(res => this.setState({ loggingIn: true }, res));

            // check credentials
            await authorizationManager.login( this.state.username, this.state.password );

            // success
            screenManager.changeScreen("Welcome");
        } catch(e) {
            AuthorizationManager.removeSessionToken();
            this.setState({ error: e instanceof Error ? e.message : e.toString(), loggingIn: false });
        }

    }

}